<template>
  <transition name="modal-fade-zoom">
    <div v-if="discipline" class="modal-overlay" @click="closeModal">
      <div class="modal-dialog" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-bookmark-star me-2"></i>
              {{ discipline.name }}
            </h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>

          <div class="modal-body">
            <div class="discipline-info">
              <h6 style="color: var(--vampire-gold);">Descrição</h6>
              <p class="mb-3">{{ discipline.overview }}</p>

              <div class="mb-3">
                <h6 style="color: var(--vampire-gold);">Mecânicas Gerais</h6>
                <ul class="list-unstyled small">
                  <li><strong>Pool de Dados:</strong> {{ discipline.mechanics?.dicePool || '—' }}</li>
                  <li><strong>Tipo de Teste:</strong> {{ discipline.mechanics?.testType || '—' }}</li>
                  <li><strong>Custo:</strong> {{ discipline.mechanics?.costSummary || '—' }}</li>
                </ul>
              </div>

              <div>
                <h6 style="color: var(--vampire-gold);">Níveis (até 5ª edição)</h6>
                <div class="levels">
                  <div v-for="lvl in discipline.levels" :key="lvl.level" class="card mb-3" style="background: var(--vampire-light-gray); border: 1px solid var(--vampire-red);">
                    <div class="card-body">
                      <h6 class="card-title" style="color: var(--vampire-gold);">
                        Nível {{ lvl.level }} — {{ lvl.name }}
                      </h6>
                      <p class="mb-2">{{ lvl.effect }}</p>
                      <div class="row small text-muted">
                        <div class="col-md-6">
                          <div><strong>Pool:</strong> {{ lvl.system?.pool || '—' }}</div>
                          <div><strong>Custo:</strong> {{ lvl.system?.cost || '—' }}</div>
                        </div>
                        <div class="col-md-6">
                          <div><strong>Duração:</strong> {{ lvl.system?.duration || '—' }}</div>
                          <div><strong>Teste:</strong> {{ lvl.system?.test || '—' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-vampire" @click="closeModal">
              <i class="bi bi-x-circle me-2"></i>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
  </template>

<script>
export default {
  name: 'DisciplineModal',
  props: {
    discipline: { type: Object, required: true }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-dialog {
  width: min(800px, 95%);
  margin: 0 1rem;
  max-height: 90vh;
  display: flex;
}

.modal-content {
  background: linear-gradient(145deg, var(--vampire-dark) 0%, var(--vampire-gray) 100%);
  border: 2px solid var(--vampire-red);
  color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  border-bottom: 1px solid var(--vampire-red);
  padding: 1rem;
}

.modal-title { color: var(--vampire-gold); margin: 0; display: flex; align-items: center; }
.btn-close { filter: invert(1); background: none; border: none; font-size: 1.5rem; cursor: pointer; }

.modal-body {
  padding: 1.5rem;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1 1 auto;
  scrollbar-width: thin; 
  scrollbar-color: rgba(212, 175, 55, 0.5) transparent; 
}


.modal-body::-webkit-scrollbar { width: 8px; height: 8px; }
.modal-body::-webkit-scrollbar-track { background: transparent; }
.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(212, 175, 55, 0.4);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.modal-body:hover::-webkit-scrollbar-thumb { background-color: rgba(212, 175, 55, 0.7); }

@media (max-width: 768px) {
  .modal-dialog { width: 95%; max-height: 92vh; }
  .modal-content { max-height: 92vh; }
}

.modal-footer {
  border-top: 1px solid var(--vampire-red);
  padding: 1rem;
  display: flex;
  justify-content: center;
}

.btn-vampire {
  background: var(--vampire-red);
  border: none;
  padding: 0.6rem 1.5rem;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: transform 0.2s ease, background 0.3s ease, box-shadow 0.2s ease;
}
.btn-vampire:hover { transform: scale(1.05); background: #a30000; box-shadow: 0 4px 12px rgba(0,0,0,0.4); }
.btn-vampire:active { transform: scale(0.95); box-shadow: 0 2px 6px rgba(0,0,0,0.3); background: #8b0000; }

.levels .card-title { margin-bottom: .25rem; }


.modal-fade-zoom-enter-active, .modal-fade-zoom-leave-active { transition: all 0.3s ease; }
.modal-fade-zoom-enter-from, .modal-fade-zoom-leave-to { opacity: 0; transform: scale(0.9); }
</style>
